import { jsx } from "react/jsx-runtime";
import RestoreIcon from "@mui/icons-material/Restore";
import { validateTidalLicense } from "../../base/index.js";
function Restore(props) {
  return /* @__PURE__ */ jsx(
    RestoreIcon,
    {
      "data-testid": "Restore",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Restore",
      "data-tidal-icon-meta": "fileActions"
    }
  );
}
Restore.tidalIconMeta = {
  categories: "fileActions",
  name: "Restore"
};
validateTidalLicense();
export {
  Restore
};
//# sourceMappingURL=Restore.js.map
